export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const API_BASE_URL_BASE = process.env.REACT_APP_API_URL_BASE;
export const API_BASE_URL_ADMIN = process.env.REACT_APP_API_URL_ADMIN;
export const REACT_APP_GA4_ID = process.env.REACT_APP_GA4_ID;